import i18next from "i18next";
import { Button, Col, Row, Typography } from "antd";
import React from "react";

const { Title, Paragraph } = Typography;

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  ErrorBoundaryState
> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  private handleGoHome = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      const title = (() => {
        try {
          return i18next.t("SomethingWentWrong");
        } catch {
          return "Something went wrong";
        }
      })();

      const description = (() => {
        try {
          return i18next.t("ErrorBoundaryDescription");
        } catch {
          return "An unexpected error occurred. Please try again.";
        }
      })();

      const buttonText = (() => {
        try {
          return i18next.t("GoToHomePage");
        } catch {
          return "Go to Home Page";
        }
      })();

      return (
        <Row
          justify="center"
          align="middle"
          style={{ minHeight: "50vh", textAlign: "center", padding: 24 }}
        >
          <Col span={24}>
            <Title level={1}>{title}</Title>
          </Col>
          <Col span={24}>
            <Paragraph type="secondary" style={{ fontSize: 16 }}>
              {description}
            </Paragraph>
          </Col>
          <Col span={24}>
            <Button type="primary" onClick={this.handleGoHome}>
              {buttonText}
            </Button>
          </Col>
        </Row>
      );
    }

    return this.props.children;
  }
}
